import { TPostReceiptConfigRequestPayload } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function postReceiptConfig({
  doctor_oid,
  clinic_id,
  receipt_pdf_header,
  receipt_pdf_footer,
  flags,
  margins,
  heights,
  footer_image_url,
  header_image_url,
  page_size,
  constraints,
}: TPostReceiptConfigRequestPayload): Promise<TrystGenericResponse<undefined>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    const formData = new FormData();

    if (receipt_pdf_header) {
      formData.append("receipt-pdf-header", receipt_pdf_header);
    }

    if (page_size) {
      formData.append("page_size", page_size);
    }

    if (receipt_pdf_footer) {
      formData.append("receipt-pdf-footer", receipt_pdf_footer);
    }

    if (clinic_id) {
      formData.append("clinic_id", clinic_id);
    }

    if (flags) {
      formData.append("flags", JSON.stringify({ ...flags }));
    }

    if (margins) {
      formData.append("margins", JSON.stringify({ ...margins }));
    }

    if (heights) {
      formData.append("heights", JSON.stringify({ ...heights }));
    }

    if (header_image_url) {
      formData.append("header_image_url", header_image_url);
    }

    if (footer_image_url) {
      formData.append("footer_image_url", footer_image_url);
    }

    console.log({ constraints });

    if (constraints) {
      formData.append("constraints", JSON.stringify({ ...constraints }));
    }
    if (doctor_oid) {
      formData.append("docid", doctor_oid);
    }

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: formData,
      mode: "cors",
      credentials: "include",
    };

    const response = await fetch(
      `${TRYST_HOST}/receipt/receipt-pdf-config`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
